export default __webpack_public_path__ + "static/media/update.976b727a.svg";